import type {
  HotspotScavengerParams,
  HotspotScavengerState,
} from '../types';

interface Props {
  params: HotspotScavengerParams;
  puzzleState: HotspotScavengerState;
}

// This puzzle is driven primarily by clicking scene hotspots.
// The panel just shows progress and clues found.
export function HotspotScavenger({ params, puzzleState }: Props) {
  const { hotspots, requiredVisitCount } = params;
  const { visitedIds, solved } = puzzleState;

  const visited = visitedIds.length;
  const clues = hotspots.filter(
    h => h.kind === 'clue' && h.clueValue !== undefined && visitedIds.includes(h.id),
  );

  return (
    <div className="puzzle-scavenger">
      {solved ? (
        <p className="puzzle-solved-msg">
          <i className="fa-solid fa-circle-check" aria-hidden="true" /> Room examined.
        </p>
      ) : (
        <>
          <p className="puzzle-narrative">
            Click objects on the scene image to examine them. Some hide glyphs, others reveal numbers.
          </p>
          <div className="puzzle-scavenger__progress">
            <span>
              {visited} / {requiredVisitCount} objects examined
            </span>
            <div className="puzzle-scavenger__bar-track">
              <div
                className="puzzle-scavenger__bar-fill"
                style={{ width: `${Math.min(100, (visited / requiredVisitCount) * 100)}%` }}
              />
            </div>
          </div>
          {clues.length > 0 && (
            <div className="puzzle-scavenger__clues">
              <p className="puzzle-scavenger__clues-label">
                <i className="fa-solid fa-hashtag" aria-hidden="true" /> Clue numbers found:
              </p>
              <ul className="puzzle-scavenger__clue-list">
                {clues.map(h => (
                  <li key={h.id} className="puzzle-scavenger__clue-item">
                    <span className="puzzle-scavenger__clue-name">{h.clueLabel ?? h.label}</span>
                    <span className="puzzle-scavenger__clue-value">{h.clueValue}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <p className="puzzle-scavenger__tip">
            <i className="fa-solid fa-arrow-pointer" aria-hidden="true" />{' '}
            Click the glowing areas on the scene image.
          </p>
        </>
      )}
    </div>
  );
}
